import './App.css';
import React, { Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Aos from 'aos';
import Toast from './components/Notifications/Toast';
import BigLoader from './components/Notifications/BigLoader';
import { ProtectedRouter } from './ProtectedRouter';
import { useDispatch, useSelector } from 'react-redux';
import SplashScreen from './screens/Splash/SplashScreen';
import { clearStoredSession, hasValidStoredSession } from './hooks/authSession';
const Groups = React.lazy(() => import('./screens/groups/GroupsPage'));
const GroupPermissions = React.lazy(() =>
  import('./screens/groups/GroupPermissions')
);
const Permissions = React.lazy(() => import('./screens/permissions/Permissions'));
const AssignPermissions = React.lazy(() =>
  import('./screens/groups/UnAssignedPermissions')
);
const AssignUserPermissions = React.lazy(() =>
  import('./screens/users/UserUnAssignedPermissions')
);
const Users = React.lazy(() => import('./screens/users/UserPage'));
const AddUser = React.lazy(() => import('./screens/users/AddUserPage'));
const ViewUserDetails = React.lazy(() => import('./screens/users/ViewUserDetails'));
const UpdateUser = React.lazy(() => import('./screens/users/UpdateUser'));
const UserPermissions = React.lazy(() =>
  import('./screens/users/UserPermissions')
);


const Products = React.lazy(() => import('./screens/products/Products'));
const AddProduct = React.lazy(() => import('./screens/products/AddProduct'));
const ViewProductDetails = React.lazy(() => import('./screens/products/ProductDetails'));
const UpdateProduct = React.lazy(() => import('./screens/products/UpdateProduct'));
const Categories = React.lazy(() => import('./screens/categories/Category'));
const StockReports = React.lazy(() => import('./screens/stock-reports/StockReports'));
const StockManagement = React.lazy(() => import('./screens/stock-reports/StockManagament'));
const Payments = React.lazy(() => import('./screens/Payments/Payments'));
const Dashboard = React.lazy(() => import('./screens/Dashboard'));
const Profile = React.lazy(() => import('./screens/Settings'));
const NotFound = React.lazy(() => import('./screens/NotFound'));
const Login = React.lazy(() => import('./screens/Login'));
const ForgotPassword = React.lazy(() => import('./screens/ForgotPassword'));
const Verification = React.lazy(() => import('./screens/Verification'));
const ResendVerification = React.lazy(() => import('./screens/ResendVerification'));
const RegistrationSuccess = React.lazy(() => import('./screens/RegistrationSuccess'));
const Register = React.lazy(() => import('./screens/Register'));

const OrdersDashboard = React.lazy(() => import('./screens/ordermanagement/OrdersDashboard'));
const OrderDetailsPage = React.lazy(() => import('./screens/ordermanagement/OrderDetailsPage'));

const Transactions = React.lazy(() => import('./screens/transactions/Transactions'));

const Customers = React.lazy(() => import('./screens/customers/Customers'));
const AddCustomer = React.lazy(() => import('./screens/customers/AddCustomer'));
const ViewCustomerDetails = React.lazy(() => import('./screens/customers/ViewCustomerDetails'));

const Currencies = React.lazy(() => import('./screens/system-parameters/currency/Currency'));
const PaymentMethods = React.lazy(() => import('./screens/system-parameters/paymentmenthods/PaymentMethods'));
const Fees = React.lazy(() => import('./screens/system-parameters/fees/Fees'));
const PaynowCredentials = React.lazy(() => import('./screens/system-parameters/paynow-credentials/PaynowCredentials'));

const Podcasts = React.lazy(() => import('./screens/podcasts/Podcasts'));
const AddPodcast = React.lazy(() => import('./screens/podcasts/AddPodcast'));
const UpdatePodcast = React.lazy(() => import('./screens/podcasts/EditPodcast'));

const News = React.lazy(() => import('./screens/news/News'));
const AddNews = React.lazy(() => import('./screens/news/AddNews'));
const UpdateNews = React.lazy(() => import('./screens/news/EditNews'));


const ProcessingFees = React.lazy(() => import('./screens/processingfees/ProcessingFees'));


const Matches = React.lazy(() => import('./screens/matchmanagement/AllMatches'));
const Leagues = React.lazy(() => import('./screens/matchmanagement/Leagues'));
const Teams = React.lazy(() => import('./screens/matchmanagement/Team'));
const Countries = React.lazy(() => import('./screens/matchmanagement/Countries'));
const LiveMatches = React.lazy(() => import('./screens/matchmanagement/LiveMatches'));
const LeagueStandings = React.lazy(() => import('./screens/matchmanagement/LeagueStandingsPage'));
const StandingsTable = React.lazy(() => import('./screens/matchmanagement/LeagueStandingsPage'));
const LeagueTeams = React.lazy(() => import('./screens/matchmanagement/LeagueTeam'));
const ZoneConfigPage = React.lazy(() => import('./screens/matchmanagement/ZoneConfig'));
const MatchManagementSetup = React.lazy(() => import('./screens/matchmanagement/MatchManagementSetup'));
const TournamentPage = React.lazy(() => import('./screens/matchmanagement/TournamentPage'));

const Tenants = React.lazy(() => import('./screens/tenants/TenantsPage'));
const TenantDetails = React.lazy(() => import('./screens/tenants/TenantDetailsPage'));

function App() {
  const [isSplashVisible, setSplashVisible] = useState(true);
  const userInfo = useSelector((state) => state.userLogin.userInfo);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Initialize AOS
  useEffect(() => {
    Aos.init();
  }, []);



  // useEffect(() => {
  //   if (location.pathname !== '/verification') {
  //     const splashShown = sessionStorage.getItem('splashShown');
  //     if (!splashShown) {
  //       const timer = setTimeout(() => {
  //         setSplashVisible(false);
  //         sessionStorage.setItem('splashShown', 'true');
  //       }, 3000);
  //       return () => clearTimeout(timer);
  //     } else {
  //       setSplashVisible(false);
  //     }
  //   } else {
  //     setSplashVisible(false);
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const hasSession = hasValidStoredSession(userInfo || {});

    if (!hasSession) {
      clearStoredSession();
      if (
        currentPath !== '/register' &&
        currentPath !== '/forgot-password' &&
        currentPath !== '/reset-password' &&
        currentPath !== '/verification' &&
        currentPath !== '/register-success' &&
        currentPath !== '/resend-verification'
      ) {
        navigate('/login');
      }
    }
  }, [navigate, userInfo, location.pathname]);


  useEffect(() => {
    Aos.init();
    const timer = setTimeout(() => setSplashVisible(false), 3000);
    return () => clearTimeout(timer);
  }, []);


  // if (isSplashVisible && (location.pathname !== '/verification' || location.pathname !== '/register-success' || location.pathname !== '/resend-verification')) {
  //   return <SplashScreen />;
  // }



  return (
    <>
      {/* Toaster */}
      <Toast />
      <Routes>
        <Route
          path="/login"
          element={
            <Suspense fallback={<BigLoader />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <Suspense fallback={<BigLoader />}>
              <ForgotPassword />
            </Suspense>
          }
        />
        <Route
          path="/reset-password"
          element={
            <Suspense fallback={<BigLoader />}>
              <ForgotPassword />
            </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback={<BigLoader />}>
              <Register />
            </Suspense>
          }
        />

        <Route
          path="/verification"
          element={
            <Suspense fallback={<BigLoader />}>
              <Verification />
            </Suspense>
          }
        />

        <Route
          path="/resend-verification"
          element={
            <Suspense fallback={<BigLoader />}>
              <ResendVerification />
            </Suspense>
          }
        />

        <Route
          path="/register-success"
          element={
            <Suspense fallback={<BigLoader />}>
              <RegistrationSuccess />
            </Suspense>
          }
        />


        {/* PROTECTED */}
        <Route element={<ProtectedRouter />}>
          <Route
            path="/"
            element={
              <Suspense fallback={<BigLoader />}>
                <Dashboard />
              </Suspense>
            }
          />
          <Route
            path="/users/all"
            element={
              <Suspense fallback={<BigLoader />}>
                <Users />
              </Suspense>
            }
          />
          <Route
            path="/user-management/user/add"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddUser />
              </Suspense>
            }
          />
          <Route
            path="/user-management/users/view/:userId"
            element={
              <Suspense fallback={<BigLoader />}>
                <ViewUserDetails />
              </Suspense>
            }
          />
          <Route
            path="/user-management/users/edit/:userId"
            element={
              <Suspense fallback={<BigLoader />}>
                <UpdateUser />
              </Suspense>
            }
          />
          <Route
            path="/admin-control/roles"
            element={
              <Suspense fallback={<BigLoader />}>
                <Groups />
              </Suspense>
            }
          />
          <Route
            path="/admin-control/permissions"
            element={
              <Suspense fallback={<BigLoader />}>
                <Permissions />
              </Suspense>
            }
          />
          <Route
            path="/admin-control/permissions/:id"
            element={
              <Suspense fallback={<BigLoader />}>
                <GroupPermissions />
              </Suspense>
            }
          />

          <Route
            path="/user-management/groups/unassigned-permissions/:id"
            element={
              <Suspense fallback={<BigLoader />}>
                <AssignPermissions />
              </Suspense>
            }
          />
          <Route
            path="/user-management/user/unassigned-permissions/:id"
            element={
              <Suspense fallback={<BigLoader />}>
                <AssignUserPermissions />
              </Suspense>
            }
          />
          <Route
            path="/users/:id/permissions"
            element={
              <Suspense fallback={<BigLoader />}>
                <UserPermissions />
              </Suspense>
            }
          />

          <Route
            path="/tenants/all"
            element={
              <Suspense fallback={<BigLoader />}>
                <Tenants />
              </Suspense>
            }
          />

          <Route
            path="/tenants/view/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <TenantDetails />
              </Suspense>
            }
          />

          {/* products */}
          <Route
            path="/store/products"
            element={
              <Suspense fallback={<BigLoader />}>
                <Products />
              </Suspense>
            }
          />
          <Route
            path="/products/add"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddProduct />
              </Suspense>
            }
          />
          <Route
            path="/store/products/view/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <ViewProductDetails />
              </Suspense>
            }
          />
          <Route
            path="/pharmacy/products/edit/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <UpdateProduct />
              </Suspense>
            }
          />
          <Route
            path="/store/categories"
            element={
              <Suspense fallback={<BigLoader />}>
                <Categories />
              </Suspense>
            }
          />
          <Route
            path="/ecommerce/orders"
            element={
              <Suspense fallback={<BigLoader />}>
                <OrdersDashboard />
              </Suspense>
            }
          />

          <Route
            path="/ecommerce/orders/:orderNumber"
            element={
              <Suspense fallback={<BigLoader />}>
                <OrderDetailsPage />
              </Suspense>
            }
          />
          <Route
            path="/store/inventory"
            element={
              <Suspense fallback={<BigLoader />}>
                <StockManagement />
              </Suspense>
            }
          />
          <Route
            path="/settings"
            element={
              <Suspense fallback={<BigLoader />}>
                <Profile />
              </Suspense>
            }
          />
          <Route
            path="/ecommerce/payments"
            element={
              <Suspense fallback={<BigLoader />}>
                <Transactions />
              </Suspense>
            }
          />
          <Route
            path="/crm/customers"
            element={
              <Suspense fallback={<BigLoader />}>
                <Customers />
              </Suspense>
            }
          />
          <Route
            path="/crm/add-customer"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddCustomer />
              </Suspense>
            }
          />
          <Route
            path="/crm/customers/:customerId"
            element={
              <Suspense fallback={<BigLoader />}>
                <ViewCustomerDetails />
              </Suspense>
            }
          />
          <Route
            path="/parameters/currencies"
            element={
              <Suspense fallback={<BigLoader />}>
                <Currencies />
              </Suspense>
            }
          />

          <Route
            path="/parameters/payment-methods"
            element={
              <Suspense fallback={<BigLoader />}>
                <PaymentMethods />
              </Suspense>
            }
          />

          <Route
            path="/parameters/fees"
            element={
              <Suspense fallback={<BigLoader />}>
                <Fees />
              </Suspense>
            }
          />

          <Route
            path="/parameters/paynow-credentials"
            element={
              <Suspense fallback={<BigLoader />}>
                <PaynowCredentials />
              </Suspense>
            }
          />

          <Route
            path="/podcasts/episodes"
            element={
              <Suspense fallback={<BigLoader />}>
                <Podcasts />
              </Suspense>
            }
          />

          <Route
            path="/clips/episodes"
            element={
              <Suspense fallback={<BigLoader />}>
                <Podcasts />
              </Suspense>
            }
          />

          <Route
            path="/podcasts/add"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddPodcast />
              </Suspense>
            }
          />

          <Route
            path="/clips/add"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddPodcast />
              </Suspense>
            }
          />

          <Route
            path="/podcasts/edit/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <UpdatePodcast />
              </Suspense>
            }
          />

          <Route
            path="/clips/edit/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <UpdatePodcast />
              </Suspense>
            }
          />

          <Route
            path="/news/all"
            element={
              <Suspense fallback={<BigLoader />}>
                <News />
              </Suspense>
            }
          />

          <Route
            path="/news/create"
            element={
              <Suspense fallback={<BigLoader />}>
                <AddNews />
              </Suspense>
            }
          />

          <Route
            path="/news/edit/:uid"
            element={
              <Suspense fallback={<BigLoader />}>
                <UpdateNews />
              </Suspense>
            }
          />

          <Route
            path="/ecommerce/processing-fees"
            element={
              <Suspense fallback={<BigLoader />}>
                <ProcessingFees />
              </Suspense>
            }
          />

          {/* =============== MATCH MANAGEMENT =============== */}
          <Route
            path="/matches/all"
            element={
              <Suspense fallback={<BigLoader />}>
                <Matches />
              </Suspense>
            }
          />

          <Route
            path="/matches"
            element={
              <Suspense fallback={<BigLoader />}>
                <MatchManagementSetup />
              </Suspense>
            }
          />
          <Route
            path="/matches/leagues"
            element={
              <Suspense fallback={<BigLoader />}>
                <Leagues />
              </Suspense>
            }
          />
          <Route
            path="/matches/leagues/create"
            element={<Navigate to="/matches/leagues" replace />}
          />
          <Route
            path="/matches/leagues/:uid/edit"
            element={<Navigate to="/matches/leagues" replace />}
          />

          {/* NEW: League Standings Routes */}
          <Route
            path="/standings"
            element={
              <Suspense fallback={<BigLoader />}>
                <LeagueStandings />
              </Suspense>
            }
          />

          <Route
            path="/standings/:leagueUid"
            element={
              <Suspense fallback={<BigLoader />}>
                <StandingsTable />
              </Suspense>
            }
          />

          {/* NEW: League Teams Management */}
          <Route
            path="/leagues/:leagueUid/teams"
            element={
              <Suspense fallback={<BigLoader />}>
                <LeagueTeams />
              </Suspense>
            }
          />

          <Route
            path="/leagues/:leagueUid/zones"
            element={
              <Suspense fallback={<BigLoader />}>
                <ZoneConfigPage />
              </Suspense>
            } />

          <Route
            path="/leagues/:leagueUid/tournament"
            element={
              <Suspense fallback={<BigLoader />}>
                <TournamentPage />
              </Suspense>
            }
          />

          <Route
            path="/matches/teams"
            element={
              <Suspense fallback={<BigLoader />}>
                <Teams />
              </Suspense>
            }
          />

          <Route
            path="/matches/countries"
            element={
              <Suspense fallback={<BigLoader />}>
                <Countries />
              </Suspense>
            }
          />

          <Route
            path="/matches/live"
            element={
              <Suspense fallback={<BigLoader />}>
                <LiveMatches />
              </Suspense>
            }
          />


        </Route>
        <Route
          path="*"
          element={
            <Suspense fallback={<BigLoader />}>
              <NotFound />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}

export default App;
